import $ from "jquery"
import "slick-carousel-latest"

let slickElementFlow = $('.js-project-flow-slider');
let slickElementFlowSubtitle = $('.js-project-flow-subtitle-slider');

function calculatePadding(){
    var statsDistanceBase = $('.js-padding-base');
    var statsDistance;

    if(statsDistanceBase.length){
        var statsDistance = $(window).width() - (statsDistanceBase.offset().left + statsDistanceBase.outerWidth());
    }

    $('.js-stats-inner').css('margin-left', statsDistance + 'px');
}

calculatePadding();

$(window).on('resize', function(){
    calculatePadding();
});

$(window).on('load', function(){
    slickElementFlow.slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        pauseOnFocus: false,
        focusOnSelect: true,
        centerMode: true,
        centerPadding: 150,
        autoplay: true,
        autoplaySpeed: 3000,
        swipe: false,
        infinite: true,
        asNavFor: '.js-project-flow-subtitle-slider',
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerPadding: 0,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: 0,
                }
            },
        ] 
    });

    slickElementFlowSubtitle.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: false,
        arrows: false,
        pauseOnFocus: false,
        swipe: false,
        infinite: true,
        asNavFor: '.js-project-flow-slider',
    });
    
    /**
     * Trust slider
     */
    $('.js-slider-trust').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: 3000,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    swipe: true
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    swipe: true
                }
            }
        ]
    });
});